import React, { Component } from 'react';
import { ListSection } from './ListItem'

function unique(arr){
  const unique = [];
  arr.map((val)=>{
    //REMOVE VALUES THAT DOES NOT CONTAIN ANYTHING
    if (!val.trim() || 0 === val.length) {
      return
    }
      else if (unique.indexOf(val) === -1) {
        return unique.push(val)
      }
  })
  return unique
}

function stringsToUniqueEntries(strArr, trim){
  var arr = strArr.map(item=>{
            //removing empty items and making an array of all items
            if(trim){
              return item.trim()
                 .replace(" ", "")
                 .replace(/ /g, '')
                 .split(',')
            }else{
              return item.split(',')
            }

        })

        if (arr.length > 0) {
          arr = arr.reduce((acc,val)=>acc.concat(val))
        }

        //reducing to one big array

          //removing duplicates
        return unique(
            arr
            )
}



const allMonths = ['Januar','Februar','Marts', 'April','Maj','Juni','Juli','August','September','Oktober','November','December'];
const allMonthsEnglish = ['January','February','March', 'April','May','June','July','August','September','October','November','December'];
const alpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ'.split('');

class IngredientsOverview extends Component {
  componentWillMount(){
    var ingredients = window.Ingredients

    //Sorting types alphabetic
    const types = stringsToUniqueEntries(ingredients.map(item=>item.types), false)
            .sort()

    var months = stringsToUniqueEntries(ingredients.map(item=>item.months), true)
    //sorting months in real order
    const sortMonths = window.english ? allMonthsEnglish : allMonths
    months = months.sort(function(a, b){
              return sortMonths.indexOf(a)
                   - sortMonths.indexOf(b)});

    const letters = unique(ingredients.map(item=>item.name.charAt(0))).sort()


    var date = new Date()
    var curMonth = date.getMonth()

    //pushing to current month
    for (var i = 0; i < curMonth; i++) {
      months.push(months.shift())
    }

    this.setState({
      months: months,
      types: types,
      typesConst: Array.from(types),
      letters: letters,
      typeSelected: false,
      ingredients: ingredients,
      sort: window.noType ? "" : "month",
    })
  }

  updateFilter = (type) => {
    this.setState({sort: type, typeSelected: false})
   }

  setType = (type) => {
    const types = this.state.types
    const idx = types.indexOf(type)

    for (var i = 0; i < idx; i++) {
      types.push(types.shift())
    }

     this.setState({
       types: types,
       sort: "type",
       typeSelected: true
     })
  }

  search = (event) =>{
    const val = event.target.value

    this.setState({
      sort: "search",
      searchVal: val,
      typeSelected:false
    })
  }

  ingredientSearch=(ingredient, search)=>{
    if (ingredient.name.toUpperCase().indexOf(search.toUpperCase()) !== -1){
      return true
    }
    if (ingredient.zip && ingredient.zip.charAt(0).indexOf(search.charAt(0)) !== -1){
      return true
    }
    if (ingredient.types.toUpperCase().indexOf(search.toUpperCase()) !== -1){
      return true
    }
    if (ingredient.months.toUpperCase().indexOf(search.toUpperCase()) !== -1){
      return true
    }
    if (ingredient.searchTags && ingredient.searchTags.toUpperCase().indexOf(search.toUpperCase()) !== -1){
      return true
    }
    return false
  }

  render() {
    return (
      <div className="ingredients-overview">
        <div className="filters">

          {window.noButtons ? null :
          <div className="filter-buttons">

            <button
              className={this.state.sort === "month" ? "active" : ""}
              onClick={()=>this.updateFilter("month")}
            >{window.button1Label || "Sæson"}</button>
            <button
              className={this.state.sort === "alpha" ? "active" : ""}
              onClick={()=>this.updateFilter("alpha")}
            >{window.button2Label || "A-Å"}</button>
            <div className="dropdown">
              <button
                className={this.state.typeSelected ? "active" : ""} type="button" data-toggle="dropdown">
                {window.button3Label ? window.button3Label : "Type"}
                <span className="caret"></span></button>

              <ul className="dropdown-menu">
                {this.state.typesConst.map(type=>(
                  <li
                    key={"button"+type}
                    onClick={()=>

                    this.setType(type)
                  }>{type}</li>
                ))}
              </ul>
            </div>
          </div>
          }

          <div className="filter-search">
            <input
              placeholder={window.searchLabel ? window.searchLabel : "SØG"}
              value={this.state.searchVal} type="search" onChange={this.search}/>
          </div>

        </div>


        {this.state.sort === "alpha" ?

          this.state.letters.map(letter=>(
            <div
              key={"section"+letter}
              className="ingredients-section">
              <div className="row">
                <div className="col-xs-12">
                  <h2>
                    {letter}
                  </h2>
                </div>
              </div>
              <ListSection
                items={this.state.ingredients.filter(i=>i.name.charAt(0)===letter).map(i=>
                <IngredientPreview {...i}/>
              )}
              />
            </div>
          ))

          :

          this.state.sort === "month" ?

          this.state.months.map(month=>(
            <div
              key={"section"+month}
              className="ingredients-section">
              <div className="row">
                <div className="col-xs-12">
                  <h2>
                    {month}
                  </h2>
                </div>

              </div>
              <ListSection
                items={this.state.ingredients.filter(i=>i.months.indexOf(month) !== -1).map(i=><IngredientPreview {...i}/>)}
              />

            </div>
          ))

          :

          this.state.sort === "search" ?

            <div className="ingredients-section">
              <div className="row">
                <div className="col-xs-12">
                  <h2>
                    {window.searchPlaceholder || "Resultat fra søgning "}{this.state.searchVal}
                  </h2>
                </div>

              </div>
              <ListSection
                items={this.state.ingredients.filter(i=>this.ingredientSearch(i, this.state.searchVal)).map(i=><IngredientPreview {...i}/>)}
              />

            </div>


          : this.state.sort === "type" ?

          this.state.types.map(type=>(
            <div
              key={"section-"+type}
              className="ingredients-section">
              <div className="row">
                <div className="col-xs-12">
                  <h2>
                    {type}
                  </h2>
                </div>

              </div>
              <ListSection
                items={this.state.ingredients.filter(i=>i.types.indexOf(type) !== -1).map(i=><IngredientPreview {...i}/>)}
              />

            </div>
          ))


          :


          <div className="ingredients-section">

            <ListSection
              items={this.state.ingredients.map(i=><IngredientPreview {...i}/>)}
            />

          </div>


          }

      </div>
              );
            }
            }

export default IngredientsOverview;


class IngredientPreview extends Component{
  render(){
    const classView = !!window.classView;

    
    return classView 
      ? <ClassIngredientPreview {...this.props} />
      : <NormalIngredientPreview {...this.props} />
  }
}

class NormalIngredientPreview extends Component{

  componentWillMount(){
      this.setState({
        loaded: this.props.img ? false : true,
        modal: window.showInModal ? true : false
      })
    }

  onImageLoad=()=>{
    this.setState({
      loaded:true
    })
  }

  render(){
    return(
    <div
      key={this.props.path}
      className="ingredient-preview" >
      <a className={this.state.modal ? "modal-button" : ""} href={this.props.path}>
        <div
          className={"responsive-img " + (this.state.loaded ? "loaded" : "")}  style={{backgroundColor: this.props.imgColor}}>
          <img
            key={this.props.img}
            onLoad={this.onImageLoad} src={this.props.img}/>
        </div>
      </a>
      <a className={this.state.modal ? "modal-button" : ""} href={this.props.path}>
        <h3>
          {this.props.name}
          {
            this.props.latinName ?
              <span className="latin-name">
                {
                  this.props.latinName.split('\n').map((item, key) => {
                    return <span key={key}>{item}<br/></span>
                  })
                }

              </span>
            : null
          }
        </h3>
      </a>
    </div>
  )}
}


class ClassIngredientPreview extends Component{

  componentWillMount(){
      this.setState({
        loaded: this.props.img ? false : true,
        modal: window.showInModal ? true : false
      })
    }

  onImageLoad=()=>{
    this.setState({
      loaded:true
    })
  }

  render(){
    return(
      <div 
        key={this.props.path}
        className="klasse-sank">
          <div>
              <img
                //onLoad={this.onImageLoad} 
                src={this.props.sanketImg}
              />
          <a className={this.state.modal ? "modal-button" : ""} href={this.props.path}>
            <div className="rounded-image ingredient-image">
              <img
              className="ingredient-icon"
              key={this.props.img}
              onLoad={this.onImageLoad} 
              src={this.props.img}
              />
            </div>
            </a>
            </div>

          <div className="info">
            <p>{this.props.name}</p>
            <p>{this.props.sanketTime}</p>
            <p>{this.props.sanketBy}</p>
          </div>
      </div>
  )}
}



// WEBPACK FOOTER //
// ./src/IngredientsOverview.js